import "./insulationbrick.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Insulationbrick() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731592080/insulationbrick2_f3drgq.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731592080/insulationbrick1_xb2rrf.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731592081/insulationbrick3_vriwrw.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731592079/insulationbrick4_sx52id.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>Insulation Bricks || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="Insulation bricks, also known as insulating fire bricks (IFBs), are lightweight, heat-resistant bricks used primarily for insulation in high-temperature applications like furnaces, kilns, and fireplaces."/>
        <meta name="keywords" content="insulation bricks, light weight fire bricks, Lagos Nigeria" />
        </Helmet>
        <h3>Insulation Brick</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Key Characteristics of Our  Insulation Brick:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Thermal Insulation 
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Light Weight & Porous
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Heat Resistant
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Low Density
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Insulation bricks, also known as insulating fire bricks (IFBs), are lightweight, heat-resistant bricks used primarily for insulation in high-temperature applications like furnaces, kilns, and fireplaces. They are specifically designed to provide thermal insulation while maintaining structural integrity at elevated temperatures. Insulation bricks differ from dense fire bricks; they’re more porous, making them less durable but much better insulators. They help retain heat, reducing energy consumption in thermal equipment.
        </div>
    </div>
  )
}
